import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendLandingPageAsset,
  BackendMutationUpdateLandingPageAssetArgs,
} from 'src/types/backend';

import { FRAGMENT_CO_ASSET } from './schema';

const MUTATION = gql`
  mutation UpdateLandingPageAsset($id: ID!, $type: String, $status: String) {
    updateLandingPageAsset(id: $id, type: $type, status: $status) {
      ...LandingPageAsset
    }
  }
  ${FRAGMENT_CO_ASSET}
`;

type Variables = BackendMutationUpdateLandingPageAssetArgs;
type Result = BackendLandingPageAsset;

export const updateLandingPageAsset = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });

  return getSingleProp<Result>(result.data);
};
